import { v4 as uuidv4 } from 'uuid';

/**
 * Inserts `count` blank days at `selectedDay`, in place. Each blank day takes
 * over the hotel of the day it displaces.
 */
export function insertBlankDays(currentDays, selectedDay, count) {
  const blankDays = Array.from({ length: count }, (_, index) => {
    const displacedDay = currentDays[selectedDay + index];
    return {
      id: uuidv4(),
      dayIndex: null,
      experienceId: null,
      hotelId: displacedDay?.hotelId ?? null,
      experienceDayIndex: null,
      experiencePricing: null,
      hotelPricing: displacedDay?.hotelPricing ?? null,
      hotelBookedOnMyOwn: displacedDay?.hotelBookedOnMyOwn ?? false,
      selectedRoom: displacedDay?.selectedRoom ?? null,
      selectedExtras: [],
    };
  });

  currentDays.splice(selectedDay, 0, ...blankDays);

  // Clear hotel from displaced original days whose hotels were moved to blank days,
  // to prevent the same hotel appearing at both the blank day position and the displaced position.
  for (let k = 0; k < count; k++) {
    const blankDay = currentDays[selectedDay + k];
    const displacedIndex = selectedDay + count + k;
    if (
      blankDay?.hotelId &&
      currentDays[displacedIndex]?.hotelId === blankDay.hotelId
    ) {
      currentDays[displacedIndex] = {
        ...currentDays[displacedIndex],
        hotelId: null,
        hotelPricing: null,
        selectedRoom: null,
        hotelBookedOnMyOwn: false,
        hotelNights: undefined,
        hotelRoomCount: undefined,
      };
    }
  }
}

/** How many consecutive days from `selectedDay` have no experience yet. */
export function countAvailableBlankDays(days, selectedDay) {
  let available = 0;
  for (let i = selectedDay; i < days.length; i++) {
    if (!days[i]?.experienceId) available++;
    else break;
  }
  return available;
}
